import { useEffect } from 'react';
import useAfterMount from './use-after-mount';
const useOnChange = (fn, values) => {
    const afterMount = useAfterMount();
    const toWatch = Object.values(values);
    useEffect(() => {
        if (afterMount) {
            fn(values);
        }
    }, toWatch);
};
export default useOnChange;
